<template>
  <div class="intro min-width">
    <div class="bg" :class="{ 'visible-half': isServed }"></div>
    <div class="me text" :class="{ visible: isServed }">
      <img src="@/assets/profile.png" class="avatar" />
      <div class="welcome">{{ this.welcomeMsgBig }}</div>
      <div class="welcome small">{{ this.welcomeMsgSmall }}</div>
    </div>

    <div
      class="btn gradient-green resume text hide"
      :class="{ visible: isServed }"
      v-on:click="showResume"
    >View My Resume</div>

    <!-- <pdf :src="require('@/assets/resume.pdf')" style="width:75%"></pdf> -->

    <!-- Interactive terminal -->
    <terminal
      v-on:serve="serveSite"
      :commandString="inputCommand"
      v-on:scroll="scrollTo"
      v-on:navigate="navigateTo"
      :class="{ 'slide-down': isServed }"
    />

    <!-- Instruction -->
    <div class="text instruction">
      Psst...try running
      <span
        class="text-terminal strong text-purple command"
        v-on:click="setCommand(suggestedCommand)"
      >{{ this.suggestedCommand }}</span>
    </div>

    <div class="bottom" :class="{ visible: isServed }">
      <!-- Button -->
      <div
        class="btn gradient-purple resume text hide"
        :class="{ visible: isServed }"
        v-on:click="scrollTo('projects')"
      >Show me what you got</div>

      <!-- Arrow -->
      <font-awesome-icon :icon="['fas', 'long-arrow-alt-down']" class="icon-arrow-down" />
    </div>
  </div>
</template>

<script>
import Terminal from "@/components/Terminal.vue";

export default {
  name: "introduction",
  components: {
    Terminal
  },
  data() {
    return {
      welcomeMsgBig: "Hi, I'm Reybel.",
      welcomeMsgSmall:
        "I make strange, and sometimes kinda neat, things like this.",
      isServed: false,
      inputCommand: "",
      suggestedCommand: null,
      commandsToTry: [
        { commandString: "npm run serve", default: true },
        { commandString: "echo hello universe" },
        { commandString: "echo goodbye world" },
        { commandString: "echo $HOME" },
        { commandString: "alert is this legal" },
        { commandString: "color green" },
        { commandString: "color red purple" },
        // { commandString: "piglatin rainforest" },
        { commandString: "cd resume" },
        { commandString: "cd projects" },
        { commandString: "git status" },
        { commandString: "clear" },
        { commandString: "cd resume" }
      ]
    };
  },
  methods: {
    serveSite() {
      this.isServed = true;
      this.$emit("serve");
    },
    setCommand(str) {
      this.inputCommand = str;

      // Suggest new command
      this.suggestRandomCommand();
    },
    startCyclingCommands() {
      // Default
      this.suggestedCommand = this.commandsToTry[0].commandString;

      // Change every 3 seconds
      var that = this;
      setInterval(() => {
        that.suggestRandomCommand();
      }, 5000);
    },
    suggestRandomCommand() {
      if (!this.isServed) {
        // show first command if page isnt served yet
        this.suggestedCommand = this.commandsToTry[0].commandString;
      } else {
        // Random command
        let randomInt = this.getRandomIntBetween(
          1,
          this.commandsToTry.length - 1
        );
        this.suggestedCommand = this.commandsToTry[randomInt].commandString;
      }
    },
    // Generate random num, inclusive
    getRandomIntBetween(min, max) {
      return Math.floor(Math.random() * (max - min + 1) + min);
    },
    scrollTo(item) {
      // Scroll page
      this.$emit("scroll", item);
    },
    navigateTo(location) {
      // Special cases
      if (location == "resume") {
        this.showResume();
      } else {
        // Open new page
        // window.open(link);
      }
    },
    showResume() {
      // Open resume pdf in new tab
      // window.open(require("@/assets/resume.pdf"));
      window.open("https://drive.google.com/file/d/1U8lQ_MZRWze2cg1btYnpskarn9ulxjpw/view?usp=sharing");
    }
  },
  computed: {},
  mounted() {
    // Cycle command suggestions
    this.startCyclingCommands();
  }
};
</script>

<style scoped>
.intro {
  width: 100%;
  display: flex;
  flex-direction: column;
  height: 100vh;
  background-color: #252538;
  align-items: center;
  overflow: hidden;
}
.intro .bg {
  width: 100%;
  height: 100%;
  position: absolute;
  background-image: url("~@/assets/intro-bg.jpg");
  background-position: center;
  background-size: cover;
  z-index: 0;
  opacity: 0;
  transition: 1.2s;
}

.visible {
  opacity: 1 !important;
}
.visible-half {
  opacity: 0.2 !important;
}

/* Section: me */
.me {
  display: flex;
  width: 60%;
  margin: 0 auto;
  flex-direction: column;
  align-items: center;
  padding-top: 4%;
  opacity: 0;
  transition: 1s;
  z-index: 1;
}
.me > .avatar {
  width: 95px;
  height: 95px;
  border-radius: 100%;
}
.me > .welcome {
  font-size: 22px;
  color: white;
  padding-top: 15px;
}
.me > .small {
  font-size: 18px;
  color: white;
  padding-top: 20px;
  padding-bottom: 28px;
}

.instruction {
  padding-top: 30px;
  padding-bottom: 18px;
  z-index: 1;
}
.instruction > .command {
  padding: 2px 7px 2px 7px;
  margin-left: 5px;
  background-color: white;
  border-radius: 5px;
  cursor: pointer;
  transition: 0.12s;
}
.instruction > .command:hover {
  background-color: #6c63ff;
  color: white !important;
}

.bottom {
  margin-top: auto;
  margin-bottom: 0%;
  padding-bottom: 30px;
  opacity: 0;
  transition: 0.1s;
  z-index: 1;
}

/* Button */
.btn-show-me {
  padding: 19px 28px 19px 28px;
  border-radius: 30px;
  background-color: grey;
  cursor: pointer;
  transition: 0.2s;
  font-size: 16px;
}
.btn-show-me:hover {
  background-color: #554edf !important;
  box-shadow: 0px 2px 10px 4px rgba(0, 0, 0, 0.2);
}

.icon-arrow-down {
  font-size: 1.4em;
  padding-top: 15px;
}

.btn {
  padding: 10px 15px 10px 15px;
  background-color: grey;
  border-radius: 6px;
  cursor: pointer;
  transition: 0.2s;
  z-index: 0;
}
.btn:hover {
  transform: scale(0.95, 0.95);
}
.hide {
  opacity: 0;
}

.terminal {
  margin-top: -120px;
  z-index: 1;
  min-height: 277px;
}
.slide-down.terminal {
  margin-top: 52px;
}
</style>
